export default __webpack_public_path__ + "static/teamsplus-2-48cadc9b03918599433ca170e347db3f.svg";